window.Utilities = (function ($, fed) {
    const self = {
        elements: {
            ids: {
                pageData: '#page-data'
            },
            attr: {
                partnerName: 'data-partner-name',
                partnerPage: 'data-page',
                componentName: 'data-component'
            }
        },
        partnerPages: {
            landing: 'Landing',
            signup: 'Signup',
            tracking: 'Tracking'
        },
        httpStatusCodes: {
            ok: 200,
            created: 201,
            unauthorized: '401',
            forbidden: '403',
            unprocessableEntity: 422,
            loginTimeout: 440,
            internalServerError: '500',
            badGateway: 502
        },
        urls: {
            errorPageUrl: '/error/error-page'
        },
        func: {
            callWebApi: function (options) {
                return $.ajax(options)
                    .then(function (data, status, jqxhr) {
                        if (!data.errorCode) {
                            return $.Deferred().resolve(data, status, jqxhr);
                        } else if (data.errorCode === self.httpStatusCodes.unauthorized) {
                            self.func.reloadPage();
                            return $.Deferred().reject({isHandled: true, errorCode: data.errorCode});
                        } else if (data.errorCode === self.httpStatusCodes.forbidden ||
                            data.errorCode === self.httpStatusCodes.internalServerError) {
                            self.func.redirect(self.urls.errorPageUrl);
                            return $.Deferred().reject({isHandled: true, errorCode: data.errorCode});
                        } else {
                            return $.Deferred().reject({isHandled: false, errorCode: data.errorCode});
                        }
                    });
            },
            redirect: function (url, queryParams) {
                if (queryParams) {
                    let queryString = '';
                    const keys = Object.keys(queryParams);
                    for (let i = 0; i < keys.length; i++) {
                        if (i !== 0) {
                            queryString += '&';
                        }
                        const key = keys[i];
                        queryString += key + '=' + queryParams[key];
                    }

                    url += '?' + queryString;
                }

                window.location.replace(url);
            },
            reloadPage: function () {
                window.location.reload(true);
            },
            openInNewTab: function (url) {
                window.open(url, '_blank');
            },
            openInExistingTab: function (url) {
                window.open(url, '_self');
            },
            openModal: function (id) {
                fed.openModal(id);
            },
            closeModal: function (id) {
                fed.closeModal(id);
            },
            isPartnerPageWithName: function (partnerName) {
                return $(self.elements.ids.pageData).attr(self.elements.attr.partnerName) === partnerName;
            },
            isPartnerPageOfType: function (partnerPage) {
                return $(self.elements.ids.pageData).attr(self.elements.attr.partnerPage) === partnerPage;
            },
            isPartnerLandingPage: function (partnerName) {
                return self.func.isPartnerPageWithName(partnerName) && self.func.isPartnerPageOfType(self.partnerPages.landing);
            },
            isPartnerSignupPage: function (partnerName) {
                return self.func.isPartnerPageWithName(partnerName) && self.func.isPartnerPageOfType(self.partnerPages.signup);
            },
            isPartnerTrackingPage: function (partnerName) {
                return self.func.isPartnerPageWithName(partnerName) && self.func.isPartnerPageOfType(self.partnerPages.tracking);
            },
            isComponentWithName: function (componentName) {
                return $(self.elements.ids.pageData).attr(self.elements.attr.componentName) === componentName;
            }
        }
    };

    return {
        httpStatusCodes: self.httpStatusCodes,
        func: self.func
    };

})(jQuery, { openModal: window.openModal, closeModal: window.closeModal });
